export default "__VITE_ASSET__VpaQ7LSe__"